var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet---History",
    transform: "translate(-1767.000000, -189.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1767.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2555408,-4.14336123e-16 L21.7444592,4.14336123e-16 C25.3105342,-2.4074122e-16 26.6036791,0.371302445 27.9073828,1.06853082 C29.2110865,1.76575919 30.2342408,2.78891348 30.9314692,4.09261719 C31.6286976,5.39632089 32,6.68946584 32,10.2555408 L32,21.7444592 C32,25.3105342 31.6286976,26.6036791 30.9314692,27.9073828 C30.2342408,29.2110865 29.2110865,30.2342408 27.9073828,30.9314692 C26.6036791,31.6286976 25.3105342,32 21.7444592,32 L10.2555408,32 C6.68946584,32 5.39632089,31.6286976 4.09261719,30.9314692 C2.78891348,30.2342408 1.76575919,29.2110865 1.06853082,27.9073828 C0.371302445,26.6036791 1.60494146e-16,25.3105342 -2.76224082e-16,21.7444592 L2.76224082e-16,10.2555408 C-1.60494146e-16,6.68946584 0.371302445,5.39632089 1.06853082,4.09261719 C1.76575919,2.78891348 2.78891348,1.76575919 4.09261719,1.06853082 C5.39632089,0.371302445 6.68946584,2.4074122e-16 10.2555408,-4.14336123e-16 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(16.000000, 16.000000) rotate(45.000000) translate(-16.000000, -16.000000) translate(8.000000, 8.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Line-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Line-8",
    transform: "translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.86774d5d1548415833147a833d3cd38b.svg";
export { ForwardRef as ReactComponent };